import { SECTION_TYPES } from '../../models/Home';
import { AlertSerializer } from './AlertSerializer';
import { MainBannerSerializer } from './MainBannerSerializer';
import { BannerSerializer } from './BannerSerializer';
import { SimpleProductSerializer } from './SimpleProductSerializer';
import { IntraSerializer } from './IntraSerializer';

class HomeSerializer {
  static deSerialize(data) {
    let alert = null;
    if (data.AlertasWeb && data.AlertasWeb.length > 0) {
      alert = AlertSerializer.deSerialize(data.AlertasWeb[0]);
    }
    return {
      alert,
      sections: (data.Items || []).map(this._deSerializeSection),
    };
  }

  static _deSerializeSection(section, index) {
    // Banners have the same type, but only the first one is a main banner
    const isMainBanner = section.IHoTipoItem === 1 && index === 0;
    const isBanner = !isMainBanner && section.IHoTipoItem === 1;
    const isProductList = section.IHoTipoItem === 2;
    const isIntraSection = section.IHoTipoItem === 3;
    const genericValues = {
      id: section.IHoId,
      name: section.IHoNombre,
      index: section.IHoOrden,
    };
    if (isMainBanner) {
      let banners = (section.ItemHomeBanner || []).map(banner => (
        MainBannerSerializer.deSerialize(banner)
      ));
      banners = [...banners].sort((a, b) => a.index - b.index);
      return {
        ...genericValues,
        type: SECTION_TYPES.MAIN_BANNER,
        banners,
      };
    } else if (isBanner) {
      return {
        ...genericValues,
        type: SECTION_TYPES.BANNER,
        banners: (section.ItemHomeBanner || []).map(banner => (
          BannerSerializer.deSerialize(banner)
        )),
      };
    } else if (isProductList) {
      const productListData = (section.ItemHomeArticulos || []).map(item => item.Articulos);
      return {
        ...genericValues,
        type: SECTION_TYPES.PRODUCT_LIST,
        products: productListData.map(SimpleProductSerializer.deSerialize),
      };
    } else if (isIntraSection) {
      const sectionsIntra = section.ItemHomeIntranet || [];
      return {
        ...genericValues,
        type: SECTION_TYPES.INTRA,
        sectionsIntra: sectionsIntra.map(IntraSerializer.deSerialize),
      };
    }
    return null;
  }
}

export { HomeSerializer };



// WEBPACK FOOTER //
// ./src/networking/serializers/HomeSerializer.js